<template>
  <div class="kefu">
    <div class="kefu_box">
      <!-- <div class="kefu_iframe"> -->
      <iframe id="kefIframe"
              :src="qiyuUrl">
      </iframe>
      <!-- </div> -->
    </div>
  </div>

</template>

<script>
import { getSessionStorage } from '../../utils/stage'
export default {
  data() {
    return {
      qiyuUrl: '',
      sdkTimer: null,
      sdkHandled: false,
    }
  },
  mounted() {
    const self = this
    ;(function (w, d, n, a, j) {
      w[n] =
        w[n] ||
        function () {
          ;(w[n].a = w[n].a || []).push(arguments)
        }
      j = d.createElement('script')
      j.async = false
      j.src =
        'https://qiyukf.com/script/fa9fdc3c4baf6db3cdfa77121d1cc324.js?hidden=1'
      // 脚本加载失败（断网 / 被拦截 / CDN 不可达）时立即提示，无需等到超时
      j.onerror = function () {
        self.onSdkError()
      }
      d.body.appendChild(j)
    })(window, document, 'ysf')
    // ysf 是异步加载器：未就绪前的调用会先入队，SDK 加载完成后自动补执行，
    // 因此这里无需再用固定延时“猜”加载时机，直接调用即可
    this.qiyu()
  },
  beforeDestroy() {
    // 组件已销毁：置位闸门，让残留的 onready / onerror 回调直接短路，
    // 否则用户离开客服页后 SDK 才就绪，仍会被强行跳转或弹出提示
    this.sdkHandled = true
    if (this.sdkTimer) {
      clearTimeout(this.sdkTimer)
      this.sdkTimer = null
    }
  },
  created() {},
  methods: {
    qiyu() {
      // sessionStorage 可能为空或被写坏，此时 onerror / 超时定时器都还没注册，
      // 直接抛异常会让页面彻底空白且没有任何提示，所以这里先兜底
      let account = null
      try {
        account = JSON.parse(getSessionStorage('accountStorage'))
      } catch (e) {
        account = null
      }
      if (!account) {
        this.onSdkError('登录信息已失效，请重新进入客服页面')
        return
      }
      ysf('config', {
        uid: account.open_id,
        data: JSON.stringify([
          { key: 'mobile_phone', value: account.phone },
          { key: 'app_name', label: '游戏项目', value: account.app_name },
          { key: 'username', label: '通行证账号', value: account.username },
          { key: 'role_name', label: '角色名', value: account.role_name },
          { key: 'uid', label: '玩家UID', value: account.uid },
          { key: 'channel', label: '渠道', value: account.channel },
          { key: 'server', label: '区服', value: account.server },
        ]),
      })

      const self = this
      // 真正等待 SDK 就绪回调触发后再取客服地址，避免同步读取标志位造成误判
      ysf('onready', function () {
        self.onSdkReady()
      })
      // 超时兜底：网络过慢或脚本长时间未就绪时给出提示
      this.sdkTimer = setTimeout(function () {
        self.onSdkError()
      }, 10000)
    },
    onSdkReady() {
      if (this.sdkHandled) return
      this.sdkHandled = true
      if (this.sdkTimer) clearTimeout(this.sdkTimer)
      this.qiyuUrl = ysf('url')
    },
    onSdkError(msg) {
      if (this.sdkHandled) return
      this.sdkHandled = true
      if (this.sdkTimer) clearTimeout(this.sdkTimer)
      alert(msg || 'sdk尚未加载成功，请稍后再试')
    },
  },
}
</script>
<style lang="less">
.user_content .content-box {
}
// .kefu {
//   width: 100%;
//   height: 100%;
//   position: absolute;
//   top: 100px;
//   left: 0;
// }
.kefu_box {
  width: 100%;
  height: calc(100vh - 90px);
  #kefIframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>